module.exports = __webpack_public_path__ + "add.077cf57d.svg";